// extracted by mini-css-extract-plugin
export var imgContent = "index-module--imgContent--CjfUB";
export var widthBiggerThanHeight = "index-module--widthBiggerThanHeight--MDMJO";
export var widthEqualHeight = "index-module--widthEqualHeight--abGNa";
export var widthSmallerThanHeight = "index-module--widthSmallerThanHeight--WYqJz";